declare var SVG2IMG: any;

import {Component, Input, OnInit, DoCheck, OnChanges} from '@angular/core';
import '../../assets/libs/liquidFillGauge.js';
import {OffersService} from './offers.service';
import {StaticService} from '../consulta/static.service';
import {BarchartService} from './barchart.service';
import {GaugeService} from './gauge.service';
import {DjangoBaseUser, DjangoSessionAuthenticationService} from '../shared/authorization/custom';
import {Observable} from 'rxjs/Observable';
import {FchartalgoService} from '../fchart/fchartalgo.service';
import {Offer} from './offer.model';
import {GeneralMessages} from '../shared/services';
import '../../assets/libs/auxiliaries.js';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss'],
  providers: [OffersService, BarchartService]
})
export class OffersComponent implements OnInit, DoCheck, OnChanges {
  @Input() offers = [];

  fstimestamp = null;
  contribucion_anual;
  accumulacion_area = 0;
  meses_con_mas_100;
  meses_con_mas_110;
  downloadurl = null;
  downloadurlword = null;

  user$: Observable<DjangoBaseUser>;

  offerloaded = null;

  captadordata = [];
  captadorIndex = 0;
  selectedCaptador = null;
  data = [];
  data2 = [];
  months = ['ENE','FEB','MAR','ABR','MAY','JUN','JUL','AGO','SEP','OCT','NOV','DIC'];

  constructor(private guage: GaugeService, private barchart: BarchartService, private offer: OffersService,
                private auth: DjangoSessionAuthenticationService, public fchartalgo: FchartalgoService,
                private messaging: GeneralMessages, private staticS: StaticService) {
    this.user$ =  this.auth.getUserLogged$();
  }

  ngDoCheck() {
    var _fs = this.fchartalgo.getFSCaptadores();
    if((this.fstimestamp != this.fchartalgo.getTimeStamp()) && _fs != null && _fs.length > 0){
      this.captadordata = this.fchartalgo.getFSCaptadores();
      this.buildBarChartData();
      this.fstimestamp = this.fchartalgo.getTimeStamp();
    }

    var _sel = this.fchartalgo.getSelectedCaptador();
    if(this.selectedCaptador != _sel && _sel != null){
      this.selectedCaptador = this.fchartalgo.getSelectedCaptador();
      for (var j = 0; j < this.captadordata.length; j++)
        if(this.captadordata[j].captador.Captador == this.selectedCaptador.Captador){
          this.captadorIndex = j;
          break;
        }
      if(_fs != null && _fs.length > 0)
        this.buildBarChartData();
    }
    if(this.offerloaded != this.staticS.getSelectedOffer()){
      this.offerloaded = this.staticS.getSelectedOffer();
      this.buildBarChartData();
      if (this.offerloaded) {
        this.downloadurl = this.offerloaded.pdf;
        this.downloadurlword = this.offerloaded.word;
      }
      else {
        this.downloadurl = null;
        this.downloadurlword = null;
      }
    }
  }

  buildBarChartData(){
    this.data = [];
    this.data2 = [];
    if (!this.offerloaded){
      for (var i = 0; i < 12; i++){
        var otr = 0;
        if(this.captadordata[this.captadorIndex].values[i] <= 100)
          otr = Math.abs(100 - this.captadordata[this.captadorIndex].values[i]);
        this.data.push( {
          label: this.months[i],
          Solar: this.captadordata[this.captadorIndex].values[i],
          Auxiliar: otr
        });
        this.data2.push( {
          label: this.months[i],
          Solar: this.captadordata[this.captadorIndex].ACS[i],
          Auxiliar: (this.captadordata[this.captadorIndex].En[i]/3600) - this.captadordata[this.captadorIndex].ACS[i]
        });
      }
    }
    else {
      var acs=this.offerloaded.acs.split(',');
      var en=this.offerloaded.en.split(',');
      var por=this.offerloaded.porcentajes.split(',');
      for (var i = 0; i < 12; i++){
        this.data.push( {
          label: this.months[i],
          Solar: parseInt(por[i]),
          Auxiliar: 100 - parseInt(por[i])
        });
        this.data2.push( {
          label: this.months[i],
          Solar: parseInt(acs[i]),
          Auxiliar: parseInt(en[i]) - parseInt(acs[i])
        });
      }
    }
    this.barchart.buildFirstBarChart( JSON.parse(JSON.stringify(this.data)) );
    this.barchart.buildSecondBarChart( JSON.parse(JSON.stringify(this.data2)) );
    if (!this.offerloaded){
      this.meses_con_mas_100 = this.fchartalgo.getMas100();
      this.meses_con_mas_110 = this.fchartalgo.getMas110();
      this.contribucion_anual = this.fchartalgo.getContribucionAnual();
      this.accumulacion_area = this.fchartalgo.getAccumulacionArea();
    } else {
      this.meses_con_mas_100 = this.offerloaded.mas100;
      this.meses_con_mas_110 = this.offerloaded.mas110;
      this.contribucion_anual = this.offerloaded.contribution;
      var captadores = this.fchartalgo.getCaptadores();
      for (var i = 0; i < captadores.length; i++){
        if (captadores[i].id == this.offerloaded.collector){
          this.accumulacion_area = this.offerloaded.total_accumulation / (this.offerloaded.num_collector * captadores[i].superficie);
          break;
        }
      }
    }
    this.guage.buildVisualization(this.contribucion_anual, this.accumulacion_area);
  }


  ngOnInit() {}

  private sortOffers() {
    this.offers.sort(function(a: Offer, b: Offer) {
      const anumber = new Date(a.created).getTime();
      const bnumber = new Date(b.created).getTime();
      return bnumber - anumber;
    });
  }

  ngOnChanges(changes) {
    if (this.offers && this.offers.length > 0)
      this.sortOffers();
  }

  warnRegister(){
    this.messaging.warning('Crea una cuenta', 'Es necesario crear una cuenta para guardar los cálculos.');
  }

  saveOffer() {
    var chart = document.getElementById('chartSVG');
    var chart2 = document.getElementById('chartSVG2');
    //var margin = {top: 0, right: 18, bottom: 10, left: 40};
    //var ext = SVG2IMG(chart, 630, 340, margin, 'png', 'png-container');
    //var ext2 = SVG2IMG(chart, 630, 340, margin, 'png', 'png-container2');
    var ext = this.offer.extractSVG(chart);
    var ext2 = this.offer.extractSVG(chart2);
    var consulta = this.fchartalgo.getConsulta();
    var options = this.fchartalgo.getOptions();

    var options = this.fchartalgo.getOptions();
    var occ = this.fchartalgo.getOccupancy();
    var occs = "";
    for (var j = 0; j < occ.length; j++)
      occs= occs + occ[j]+ ",";
    occs = occs.slice(0, -1);

    var acs = "";
    for (var j = 0; j < this.captadordata[this.captadorIndex].ACS.length; j++)
      acs = acs + Math.round(this.captadordata[this.captadorIndex].ACS[j])+ ",";
    acs = acs.slice(0, -1);

    var en = "";
    for (var j = 0; j < this.captadordata[this.captadorIndex].En.length; j++)
      en = en + Math.round(this.captadordata[this.captadorIndex].En[j]/3600) + ",";
    en = en.slice(0, -1);

    var pors = "";
    for (var j = 0; j < this.captadordata[this.captadorIndex].values.length; j++)
      pors = pors + this.captadordata[this.captadorIndex].values[j] + ",";
    pors = pors.slice(0, -1);

    var perdidas = (this.fchartalgo.get_acs_total_default() - this.fchartalgo.get_acs_total()) * 100 / this.fchartalgo.get_acs_total_default();


    var offer_save = {
      project: consulta.project,
      province: consulta.selectedProvince.id,
      centralization: consulta.centralization,
      city: consulta.city,
      zona: consulta.zona,
      address: consulta.address,
      project_type: consulta.selectedProjectType,
      vivienda_type: consulta.tipovivienda,
      unidad: consulta.units,
      num_rooms: consulta.num_unidades,
      num_persons_room: consulta.num_ocupantes,
      unit_volume: consulta.volumen,
      unit_volume_default: consulta.default_volumen,
      c_plana: options.c_plana,
      interacumulador: options.interacumulador,
      forzado: options.forzado,
      collector: this.selectedCaptador.id,
      num_collector: this.selectedCaptador.unidades,
      total_accumulation: consulta.accumulation,
      contribution: Math.round(this.contribucion_anual*100) / 100,
      contribution_default: consulta.contribucion_default,
      deviation: consulta.desviacion,
      exchange_factor: this.selectedCaptador.factor_intercambio,
      inclination: consulta.inclinacion,
      output_temp: consulta.temperatura_deseada,
      occupancy_percentage: occs,
      referency_number: new Date().toLocaleString(),
      acs_total: Math.round(this.fchartalgo.get_acs_total()),
      en_total: Math.round(this.fchartalgo.get_en_total()),
      perdidas: perdidas,
      mas100:this.meses_con_mas_100,
      mas110:this.meses_con_mas_110,
      acs:acs,
      en:en,
      porcentajes:pors
    };

    offer_save['d3img1'] = ext;
    offer_save['d3img2'] = ext2;
    var ready = this.testOffer(offer_save);
    console.log(offer_save);
    if (ready) {
      this.offer.data = offer_save;
      this.offer.save(this.offers)
        .subscribe(data => {
          this.offerSaved(data);
          this.offer.data.created = data.created;
          this.sortOffers();
        });
    }
  }

  offerSaved(data) {
    this.messaging.info('', 'Consulta guardada correctamente.\n\n Podrá cargar sus datos en cualquier momento, \ny descargar su memoria de cálculo.');
    this.downloadurl = data.pdf;
    this.downloadurlword = data.word;
    this.staticS.selectOffer(data);
  }

  downloadOffer(){
    var link;
    var filename = 'consulta.pdf';
    link = document.createElement('a');
    link.setAttribute('href', this.downloadurl);
    link.setAttribute('download', filename);
    link.setAttribute('target', '_blank');
    link.click();
  }

  downloadOfferWord(){
    var link;
    var filename = 'consulta.docx';
    link = document.createElement('a');
    link.setAttribute('href', this.downloadurlword);
    link.setAttribute('download', filename);
    link.setAttribute('target', '_blank');
    link.click();
  }

  testOffer(offer) {
    var message = "";
    if(!offer.project || offer.project.length == 0)
      message = message + "Especifica el nombre del proyecto." + "\n";
    if(!offer.province || offer.province.length == 0)
      message = message + "Elige una provincia." + "\n";
    if(!offer.city || offer.city.length == 0)
      message = message + "Especifica la ciudad donde se encuentra el proyecto." + "\n";
    if(!offer.num_rooms || offer.num_rooms.length == 0)
      message = message + "Especifica el número de unidades." + "\n";
    if(!offer.num_persons_room || offer.num_persons_room.length == 0)
      message = message + "Especifica el número de personas por unidad." + "\n";
    if(!offer.unit_volume || offer.unit_volume.length == 0)
      message = message + "Especifica el volumen de agua consumido por unidad." + "\n";
    if(!offer.collector || offer.collector.length == 0)
      message = message + "Selecciona un modelo de captador." + "\n";
    if(offer.num_collector == null || offer.num_collector.length == 0)
      message = message + "Especifica el número de captadores." + "\n";
    if(!offer.total_accumulation || offer.total_accumulation.length == 0)
      message = message + "Especifica el volumen total de acumulación de agua caliente." + "\n";
    if(!offer.contribution || offer.contribution.length == 0)
      message = message + "Especifica el porcentaje de contribución del sistema." + "\n";
    if(offer.deviation == null || offer.deviation.length == 0)
      message = message + "Especifica la desviación de la instalación." + "\n";
    if(offer.inclination == null || offer.inclination.length == 0)
      message = message + "Especifica la inclinación del techo." + "\n";
    if(offer.output_temp == null || offer.output_temp.length == 0)
      message = message + "Especifica la temperatura de salida del sistema." + "\n";

    if (message.length > 0){
      this.messaging.info('', message);
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/offers/offers.component.ts